export var StoreCategory;
(function (StoreCategory) {
    StoreCategory["Iqos"] = "iqos";
    StoreCategory["Gas"] = "gas_station";
    StoreCategory["Cafe"] = "cafe";
    StoreCategory["Bar"] = "bar";
    StoreCategory["Store"] = "store";
})(StoreCategory || (StoreCategory = {}));
export var StoreService;
(function (StoreService) {
    StoreService["Recharge"] = "recharge";
    StoreService["Heets"] = "heets";
    StoreService["Terea"] = "terea";
    StoreService["Fiit"] = "fiit";
    StoreService["Accessories"] = "accessories";
    StoreService["Engraving"] = "engraving";
    StoreService["Lending"] = "lending";
    StoreService["Cleaning"] = "cleaning";
    StoreService["Sale"] = "sale";
    StoreService["Maintenance"] = "maintenance";
})(StoreService || (StoreService = {}));
export var StoreProductVersion;
(function (StoreProductVersion) {
    StoreProductVersion["Version3"] = "version_3";
    StoreProductVersion["Version3Duo"] = "version_3_duo";
    StoreProductVersion["VersionOriginals"] = "version_iqos_originals";
    StoreProductVersion["Version3Multi"] = "version_3_multi";
    StoreProductVersion["Version24"] = "version_2_4";
    StoreProductVersion["Version24Plus"] = "version_2_4_plus";
    StoreProductVersion["VersionLilSolidEz"] = "version_lil_solid_ez";
    StoreProductVersion["VersionIlumaPrime"] = "version_iluma_prime";
    StoreProductVersion["VersionIluma"] = "version_iluma";
    StoreProductVersion["VersionIlumaOne"] = "version_iluma_one";
    StoreProductVersion["VersionIlumaIPrime"] = "version_iluma_i_prime";
    StoreProductVersion["VersionIlumaI"] = "version_iluma_i";
    StoreProductVersion["VersionIlumaIOne"] = "version_iluma_i_one";
})(StoreProductVersion || (StoreProductVersion = {}));
